
import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'component/utils/Modal'

const PricebannerWarningModal = ({
  isOpen,
  onClose,
  onNewRegister,
  onSeeExisting,
  details,
  detailsAsHtml,
  translate,
  customTitle,
  customQuestion
}) => (
  <Modal
    isOpen={isOpen}
    onCloseModal={onClose}
    showHeader={false}
    showFooter={false}
    center
    size="sm"
    className="pricebanner-warning-modal"
  >
    <div>
      <h2 style={{ fontSize: '24px', fontWeight: '600', marginBottom: '12px' }}>
        {customTitle || translate('datasheetManagement.save.already.existent.title')}
      </h2>

      <p style={{ fontSize: '16px', marginBottom: '24px', color: '#000000' }}>
        {detailsAsHtml ? (
          <span dangerouslySetInnerHTML={{ __html: detailsAsHtml }} />
        ) : (
          details
        )}
        <br />
        <br />
        {customQuestion || translate('price.banner.registered.param')}
      </p>

      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '16px', marginTop: '50px' }}>
        <button
          onClick={onNewRegister}
          style={{
            border: '1.5px solid #41A017',
            borderRadius: '8px',
            padding: '12px 16px',
            fontWeight: '600',
            color: '#41A017',
            backgroundColor: '#fff',
            cursor: 'pointer'
          }}
        >
          {(translate('position.register.edit'))}
        </button>

        <button
          onClick={onSeeExisting}
          style={{
            backgroundColor: '#41A017',
            color: '#fff',
            border: 'none',
            borderRadius: '8px',
            padding: '12px 16px',
            fontWeight: '600',
            cursor: 'pointer'
          }}
        >
          {(translate('price.banner.see.registered'))}
        </button>
      </div>
    </div>
  </Modal>
)

PricebannerWarningModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onNewRegister: PropTypes.func.isRequired,
  onSeeExisting: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  details: PropTypes.string.isRequired,
  detailsAsHtml: PropTypes.string,
  customTitle: PropTypes.string,
  customQuestion: PropTypes.string,
}

export default PricebannerWarningModal